export const ADMIN_BASE_PATH = "/control-center-x9k2m7-admin";

export const ADMIN_ROUTE_PATHS = {
    base: ADMIN_BASE_PATH,
    log: `${ADMIN_BASE_PATH}/log`,
    message: `${ADMIN_BASE_PATH}/message`,
    systemProps: `${ADMIN_BASE_PATH}/system_props`,
    telegramBanners: `${ADMIN_BASE_PATH}/telegram-banners`,
};
